import React, { useEffect, useState, useContext } from "react";
import axios from "axios";

import FavoritesContext from "contexts/FavoritesContext";
import NavSearch from "components/NavSearch";
import RecipeCard from "components/RecipeCard";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";

function Favorites() {
  // "contextFavItems" variable used to consume/use Favorites context
  const [contextFavItems, setContextFavItems] = useContext(FavoritesContext);

  // Define initial state
  const [recipeData, setRecipeData] = useState([]);

  useEffect(() => {
    // Get all recipes from Express server
    const getRecipeData = async function() {
      await axios.get("/food-recipe-react/api/recipes")
        .then(response => {
          setRecipeData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    };
    
    getRecipeData();
    window.scrollTo(0, 0); // scroll to top of page on page load
  }, []);

  // "recipes" is an array of results in the API so "recipeData.recipes" is used to access it
  const recipes = recipeData.recipes;

  return (
    <>
      {/* NavSearch component */}
      <NavSearch />

      <Container maxWidth="lg">
        <p><strong>Favorites</strong></p>
        {(contextFavItems.length === 0) ? "No favorite recipes" : ""}
        <Grid container sx={{ my: 1 }} spacing={3}>
          {recipes && recipes.map(function(recipe) {
            return (
              <>
                {/* only display favorited items */}
                {contextFavItems.includes(recipe.id) &&
                  <Grid xs={12} sm={6} md={4} lg={4}>
                    {/* RecipeCard component */}
                    <RecipeCard key={recipe.id} recipe={recipe} />
                  </Grid>
                }
              </>
            );
          })}
        </Grid>
      </Container>
    </>
  );
}

export default Favorites;